var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.726,
    height: 17.875,
    viewBox: "0 0 18.726 17.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#587386;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.779,51.755h6.253a5.853,5.853,0,0,1-2.043,3.318h-.827a.39.39,0,0,0,0,.78h9.305a.39.39,0,0,0,0-.78h-.83a5.852,5.852,0,0,1-2.042-3.318h6.252a1.33,1.33,0,0,0,1.329-1.328V39.306a1.33,1.33,0,0,0-1.329-1.328H97.779a1.33,1.33,0,0,0-1.329,1.328v11.12a1.33,1.33,0,0,0,1.329,1.328Zm16.069-.78H97.779a.549.549,0,0,1-.548-.548V48.966H114.4v1.461a.549.549,0,0,1-.548.548Zm-8.283-2.789h0Zm2.984,0h0Zm2.98,0h0Zm-13.75-9.427h16.069a.549.549,0,0,1,.548.548v8.879h-2.086V43.55a.39.39,0,0,0-.39-.39h-1.562a.39.39,0,0,0-.39.39v4.635h-.638V44.721a.39.39,0,0,0-.39-.39h-1.562a.39.39,0,0,0-.39.39v3.465h-.642v-1.9a.39.39,0,0,0-.39-.39h-1.562a.39.39,0,0,0-.39.39v1.9H97.23V39.306a.549.549,0,0,1,.548-.548Z",
    transform: "translate(-96.45 -37.978)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.177,351.96h-.615a.39.39,0,1,0,0,.78h.615a.39.39,0,0,0,0-.78Z",
    transform: "translate(-322.504 -340.365)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M281.287,90.836l7.591-3.9-.2.718a.39.39,0,1,0,.753.205l.449-1.646a.39.39,0,0,0-.274-.479l-1.646-.449a.39.39,0,0,0-.205.753l.757.207-7.585,3.9a.39.39,0,1,0,.357.694Z",
    transform: "translate(-273.914 -83.527)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.654,86.038h3.451a.39.39,0,0,0,0-.78h-3.451a.39.39,0,0,0,0,.78Z",
    transform: "translate(-138.646 -83.512)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.654,145.018h3.451a.39.39,0,0,0,0-.78h-3.451a.39.39,0,0,0,0,.78Z",
    transform: "translate(-138.646 -140.314)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.654,203.988h3.451a.39.39,0,0,0,0-.78h-3.451a.39.39,0,0,0,0,.78Z",
    transform: "translate(-138.646 -197.106)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.654,262.968h3.451a.39.39,0,0,0,0-.78h-3.451a.39.39,0,0,0,0,.78Z",
    transform: "translate(-138.646 -253.908)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.f6c1fef50d73258c8fd4bc0f6c0e7a78.svg";
export { ForwardRef as ReactComponent };